<template>
    <div class="">
        <h5 class="info-header">项目经理 <span v-if="!basicIsShow" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别,无法修改)</span>
            <div>
                <el-button  v-if="basicIsShow" icon="el-icon-plus" @click="add">新增</el-button>
            </div>
        </h5>
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane label="项目经理维护" name="managerWh">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>姓名</th>
                        <th><b>*</b>身份证</th>
                        <th><b>*</b>手机</th>
                        <th><b>*</b>邮箱</th>
                        <th><b>*</b>社保证明</th>
                        <th>状态</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="c, i in managers">
                        <td>{{i+1}}</td>
                        <td>{{c.name}}</td>
                        <td><span :title="c.idCard">{{c.idCard}}</span></td>
                        <td>{{c.mobile}}</td>
                        <td><span title="c.email">{{c.email}}</span></td>
                        <td>
                            <a class="vlink" v-if="c.baseFileList.length" :href="`${downApi}?fileName=${c.baseFileList[0].fileName}&fileOldName=${encodeURIComponent(c.baseFileList[0].fileOldName)}`">{{c.baseFileList[0].fileOldName}}</a>
                            <span v-if="!c.baseFileList.length">无附件</span>
                        </td>
                        <td>
                            <span v-if="c.status == '0' || c.status == null">未认证</span>
                            <span v-if="c.status=='1'">已认证</span>
                            <span v-if="c.status=='2'">已离职</span>
                        </td>
                        <td>
                            <a @click.prevent="viewDetail(i)" class="edit-btn">查看详情</a>
                            <a v-if="basicIsShow" @click.prevent="edit(i)" class="edit-btn">编辑</a>
                            <a v-if="basicIsShow && c.status!='1'" @click.prevent="remove(i)" class="delete-btn">删除</a>
                        </td>
                    </tr>
                    <tr v-if="!managers.length"><td colspan=13>暂无数据</td></tr>
                </table>
                <div class="splitter"></div>
                <div class="text-center">
                    <el-button v-if="basicIsShow" :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="项目经理变更" name="managerBg">
                <el-form class="invite-form" label-width="140px" ref="form" :model="form">

                    <el-row>

                        <el-col :span="8">
                            <el-form-item label="合同名称：" prop="name">
                                <el-input size="medium" v-model="form.name" clearable></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="3" :offset="1">
                            <el-button type="warning" class="btn-theme" size="medium" @click="getContractBillsByStock" icon="el-icon-search">搜索</el-button>
                        </el-col>

                    </el-row>
                    <el-table :data="contractBills"  border style="width: 100%;margin-top:30px" size="mini" strip :header-cell-style="{background:'#f5f5f5'}">
                        <el-table-column type="index" label="序号" width="55"></el-table-column>
                        <el-table-column prop="companyName" label="所属公司" width="80"></el-table-column>
                        <el-table-column prop="contractName" label="合同名称" width="104"></el-table-column>
                        <el-table-column prop="oldUserMessageName" label="变更前项目经理" width="110"></el-table-column>
                        <el-table-column prop="userMessageName" label="变更后项目经理" width="110"></el-table-column>
                        <el-table-column prop="idCard" label="身份证号码" width="150"></el-table-column>
                        <el-table-column prop="fphone" label="手机号码" width="100"></el-table-column>
                        <el-table-column prop="approveStatus" label="变更状态" width="90">
                            <template slot-scope="scope">
                                <template v-if="scope.row.approveStatus == -2">
                                    无变更
                                </template>
                                <template v-if="scope.row.approveStatus == -1">
                                    变更驳回
                                </template>
                                <template v-if="scope.row.approveStatus == 0">
                                    变更待确认
                                </template>
                                <template v-if="scope.row.approveStatus == 1">
                                    变更通过
                                </template>
                                <template v-if="scope.row.approveStatus == 2">
                                    已撤回
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="140" label="操作">
                            <template slot-scope="scope">
                                <a class="buttonDiv" @click="getChanageDetail(scope.row,true)" v-if="scope.row.approveStatus==-2 ||scope.row.approveStatus==1||scope.row.approveStatus==-1">变更</a>
                                <a class="buttonDiv" @click="recallChanage(scope.row)" v-if="scope.row.approveStatus==0">撤回</a>
                                <a class="buttonDiv" @click="getChanageDetail(scope.row,true)" v-if="scope.row.approveStatus==2">编辑</a>
                                <a class="buttonDiv" @click="deleteChanage(scope.row)" v-if="scope.row.approveStatus==2">删除</a>
                                <a class="buttonDiv" @click="getChanageDetail(scope.row,false)" v-if="scope.row.approveStatus==0">详情</a>
                                <a class="buttonDiv" @click="getChangeHistory(scope.row.contractId)">变更历史</a>
                            </template>
                        </el-table-column>

                    </el-table>
                    <div class="pagination-div">
                        <el-pagination background  layout="total, prev, pager, next" prev-text="上一页" next-text="下一页" :page-size="contractBillPagination.pageSize" :current-page="contractBillPagination.pageNumber" :total="contractBillPagination.total" @current-change="changeHandleCurrentChange"></el-pagination>
                    </div>
                </el-form>
            </el-tab-pane>
        </el-tabs>

        <el-dialog :title="operateTitle" :visible.sync="changeManagerFormVisible">
            <el-form :model="managerPerson" label-width="120px" :rules="changeManagerRules" ref="changeManagerForm" class="supplier-form">
                <el-form-item label="原项目经理：" prop="oldUserMessageName"><el-input type="text" v-model.trim="managerPerson.oldUserMessageName" auto-complete="off" disabled></el-input></el-form-item>
                <el-form-item label="新项目经理：" prop="name">
                    <el-select v-model="managerPerson.name" placeholder="请选择项目经理"  @change="changeName" :disabled="changeManageShow">
                        <el-option :label="item.name" :value="item.id" v-for="item in projectManagerList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="身份证号码：" prop="IDCard"><el-input type="text" v-model="managerPerson.IDCard" auto-complete="off" :maxlength="11" disabled></el-input></el-form-item>
                <el-form-item label="手机号码：" prop="phone"><el-input type="text" v-model="managerPerson.phone" auto-complete="off" disabled></el-input></el-form-item>
                <el-form-item label="变更原因：" prop="changeReason">
                    <el-radio-group v-model="managerPerson.changeReason" @change="reasonChange" :disabled="changeManageShow">
                        <el-radio label="1">离职</el-radio>
                        <el-radio label="2">能力不足</el-radio>
                        <el-radio label="4">黑名单</el-radio>
                        <el-radio label="3">其它（需说明原因）</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="变更说明：" prop="changeExplain" v-if="changeExplainShow">
                    <el-input type="text" v-model="managerPerson.changeExplain" :disabled="changeManageShow"></el-input>
                </el-form-item>
                <el-form-item label="附件：" prop="baseFileList" v-if="approveStatus != 0">
                    <el-upload class="upload"
                               :action="uploadApi"
                               :on-success="handleChange"
                               :limit="3"
                               multiple
                               :on-exceed="handleExceed"
                               :file-list="managerPerson.managerFiles">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="附件：" prop="" v-if="approveStatus == 0">
                    <div v-for="file in managerPerson.managerFiles" :key="file.id">
                        <a class="vlink" v-if="file.id" :href="downManagerApi +'?path=/'+ file.filePath+'&name='+file.fileName" target="_blank" :download="file.fileName">
                            {{file.fileName}}
                        </a>
                        <span v-else>{{file.fileName}}</span>
                    </div>
                </el-form-item>
                <el-form-item label="审批说明：" prop="" v-if="changeManageShow">
                    <span>{{approveRemark}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeManagerFormVisible = false">取 消</el-button>
                <el-button type="primary" v-if="approveStatus != 0" @click="submitChangeManager">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="变更历史" :visible.sync="recordDialogVisible" width="1037px">
            <el-table :data="managerChangeRecords"  border style="width: 100%;margin-top:30px" size="mini" strip :header-cell-style="{background:'#f5f5f5'}">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="oldUserMessageName" label="变更前项目经理" width="110"></el-table-column>
                <el-table-column prop="userMessageName" label="变更后项目经理" width="110"></el-table-column>
                <!-- <el-table-column prop="contractName" label="合同名称" width="90"></el-table-column> -->
                <el-table-column prop="changeReason" label="变更原因" width="90">
                    <template slot-scope="scope">
                        <template v-if="scope.row.changeReason == 1">
                            离职
                        </template>
                        <template v-if="scope.row.changeReason == 2">
                            能力不足
                        </template>
                        <template v-if="scope.row.changeReason == 3">
                            其他-{{scope.row.changeExplain}}
                        </template>
                        <template v-if="scope.row.changeReason == 4">
                            黑名单
                        </template>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="changeExplain" label="变更说明" width="120"></el-table-column> -->
                <el-table-column prop="date" label="附件" width="90">
                    <template slot-scope="scope">
                        <div v-for="file in scope.row.baseFiles" :key="file.id">
                            <a class="vlink" v-if="file.id" :href="downManagerApi +'?path='+file.filePath+'&name='+file.fileName" :download="file.fileName">
                                {{file.fileName}}
                            </a>
                            <span v-else>{{file.fileName}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createName" label="变更人" width="80"></el-table-column>
                <el-table-column prop="changeDate" label="变更时间" width="140"></el-table-column>
                <el-table-column prop="approveStatus" label="变更状态" width="90">
                    <template slot-scope="scope">
                        <template v-if="scope.row.approveStatus == -1">
                            变更驳回
                        </template>
                        <template v-if="scope.row.approveStatus == 0">
                            变更待确认
                        </template>
                        <template v-if="scope.row.approveStatus == 1">
                            变更通过
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="approveRemark" label="审批说明" width="150"></el-table-column>
                <el-table-column align="center" width="80" label="操作">
                    <template slot-scope="scope">
                        <a class="buttonDiv" @click="getChanageDetail(scope.row,false)">详情</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-div">
                <el-pagination background  layout="total, prev, pager, next" prev-text="上一页" next-text="下一页" :page-size="teamChangePagination.pageSize" :current-page="teamChangePagination.pageNumber" :total="teamChangePagination.total" @current-change="changeTeamCurrentChange"></el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="recordDialogVisible = false">返 回</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="operateTitle" :visible.sync="managerFormVisible">
            <el-form :model="manager" label-width="100px" :rules="rules" ref="managerForm" class="supplier-form">
                <el-form-item label="姓名：" prop="name"><el-input type="text" v-model.trim="manager.name" auto-complete="off" :disabled="operateType=='view'||(notCanOperate&&operateType=='edit')"></el-input></el-form-item>
                <el-form-item label="身份证：" prop="idCard">
                    <el-input type="text" v-model="manager.idCard" auto-complete="off" @change="setManagerPhone" :disabled="operateType=='view'||(notCanOperate&&operateType=='edit')"></el-input>
                </el-form-item>
                <el-form-item label="手机：" prop="mobile"><el-input type="text" v-model="manager.mobile" auto-complete="off" :maxlength="11" :disabled="operateType=='view'||(notCanOperate&&operateType=='edit')"></el-input></el-form-item>
                <el-form-item label="办公电话：" prop="officeTel"><el-input type="text" v-model="manager.officeTel" auto-complete="off" :disabled="operateType=='view'"></el-input></el-form-item>
                <el-form-item label="邮箱：" prop="email"><el-input type="text" v-model="manager.email" auto-complete="off" :disabled="operateType=='view'||(notCanOperate&&operateType=='edit')"></el-input></el-form-item>
                <el-form-item label="专业：" prop="major"><el-input type="text" v-model="manager.major" auto-complete="off" :disabled="operateType=='view'"></el-input></el-form-item>
                <el-form-item label="建造师级别：" prop="grade"><el-input type="text" v-model="manager.grade" auto-complete="off" :disabled="operateType=='view'"></el-input></el-form-item>
                <el-form-item label="证书编号：" prop="certificateNo"><el-input type="text" v-model="manager.certificateNo" auto-complete="off" :disabled="operateType=='view'"></el-input></el-form-item>
                <el-form-item label="业绩：" prop="achievement"><el-input type="text" v-model="manager.achievement" auto-complete="off" :disabled="operateType=='view'"></el-input></el-form-item>
                <el-form-item label="社保证明：" prop="baseFileList">
                        <el-upload
                                :disabled="operateType=='view'||(notCanOperate&&operateType=='edit')"
                                :action="uploadApi"
                                :on-success="setPhotoList"
                                :limit="1"
                                :on-exceed="handleExceed"
                                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                                :file-list="manager.baseFileList">
                            <el-button size="small" type="primary" :disabled="operateType=='view'||(notCanOperate&&operateType=='edit')">点击上传</el-button>
                        </el-upload>(需提供6个月社保缴纳记录证明)
                    </el-form-item>
            </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button @click="managerFormVisible = false">取 消</el-button>
        <el-button v-if="operateType=='edit'||operateType=='add'"  type="primary" @click="submitManager">确 定</el-button>
        </div>
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import util from '@/util'
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { ADD_MANAGER, EDIT_MANAGER, REMOVE_MANAGER } from '@/store/mutation-types'
    import { managerRules } from '@/util/rules'
    import apis from '@/store/apis'

    export default {
        name: 'supplier-manager',
        data () {
            return {
                rules: managerRules,
                changeManagerRules:{
                    name:[{required:true,message:'请选择项目经理',trigger:'blur'}],
                    changeReason:[{required:true,message:'请选择变更原因'}],
                    changeExplain:[{required:true,message:'请填写变更说明',trigger:'blur'}]
                },
                form: {
                    name: ""
                },
                manager:{
                    name:'',
                    idCard: '',
                    mobile:'',
                    officeTel:'',
                    email:'',
                    major:'',
                    grade:'',
                    certificateNo:'',
                    achievement:'',
                    baseFileList: []
                },
                managerPerson:{
                    type:'0',
                    position:'',
                    name:'',
                    IDCard:'',
                    phone:'',
                    loginNumber:'',
                    userMessageId:'',
                    supplierManagerId:'',
                    state:'0',
                    positionName:'',
                    userType:'',
                    changeReason:'1',
                    changeExplain:'',
                    managerFiles:[],
                    oldUserMessageName:'',
                    teamId:'',
                    teamChangeId:'',
                    contractId:'',
                    projectId:''
                },
                teamChangePagination:{
                    total:0,
                    pageNumber:1,
                    pageSize:10
                },
                contractBillPagination:{
                    total:0,
                    pageNumber:1,
                    pageSize:10
                },
                projectManagerList:[] , // 项目经理列表
                backProjectManagerId:'', // 用于编辑项目经理得时候回显
                activeName: 'managerWh',
                managerChangeRecords: [],
                contractBills: [],
                managerFormVisible:false,
                changeManagerFormVisible:false,
                changeExplainShow:false,
                isSubmit:false,
                editIndex:void(0),
                downManagerApi: `${util.baseUrl}rest/api/sftp/download`,
                downApi: `${util.baseUrl}rest/file/down`,
                uploadApi: `${util.baseUrl}rest/file/upload?type=2`,
                linksMap: {},
                hasLittleStatus012: {flag:false},
                hasLittleStatus3: {flag:false},
                recordDialogVisible:false,
                notCanOperate:true,
                operateType:'',
                operateTitle:'',
                basicIsShow: false,  // 判断信息是否修改
                contractId:'',
                approveStatus:'',
                changeManageShow:false,
                approveRemark:''
            }
        },
        computed:mapGetters(['managers', 'linkpersons']),
        methods: {
            ...mapActions(['getManagers','addOrEditManager','removeManager','submitManagers', 'checkDelManager', 'getLinkPersons']),
            ...mapMutations({addManager:ADD_MANAGER,editManager:EDIT_MANAGER,delManager:REMOVE_MANAGER}),
            handleClick(val){
                this.activeName = val.name;
                console.log(val.name,'101037');
                if(val.name == 'managerBg'){
                    this.getContractBillsByStock();
                }
            },
            add(){
                this.editIndex=void(0)
                this.operateType='add',
                this.operateTitle='新增项目经理',
                this.notCanOperate=false
                this.managerFormVisible = true
                this.$nextTick(()=>{
                    this.manager = {
                        name: '',
                        idCard: '',
                        mobile: '',
                        officeTel: '',
                        email: '',
                        major: '',
                        grade: '',
                        certificateNo: '',
                        achievement: '',
                        baseFileList: []
                    }
                    this.$refs.managerForm.resetFields()
                })
            },
            edit(i){
                this.operateType='edit',
                this.operateTitle='编辑项目经理',
                this.notCanOperate = true;
                this.editIndex = i
                this.manager = Object.assign({}, this.managers[i])
                if(this.managers[i].status!='1'){
                    this.notCanOperate = false;
                }
                console.log( this.notCanOperate ,'wudi')
                if (this.manager.baseFileList.length > 0) {
                    this.manager.baseFileList[0].name = this.manager.baseFileList[0].fileOldName
                }

                this.managerFormVisible = true
            },
            viewDetail(i){
                this.operateType='view',
                this.operateTitle='项目经理详情',
                this.editIndex = i
                this.manager = Object.assign({}, this.managers[i])
                this.managerFormVisible = true
            },
            remove(i){
                this.$confirm('此操作将删除该条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.checkDelManager(this.managers[i].id).then((res)=>{
                        if (res.data.result) {
                            this.removeManager(i).then(()=>{
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                })
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }).catch((e) => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            submitChangeManager() {
                this.$refs.changeManagerForm.validate((valid) => {
                    if (valid) {
                        if (this.managerPerson.managerFiles && this.managerPerson.managerFiles.length > 0) {
                            this.managerPerson.managerFiles.forEach(item => {
                                item.fileName = item.fileOldName
                            })
                        }
                        let params = {
                            contractId: this.managerPerson.contractId,
                            //floginnum: this.managerPerson.loginNumber,
                            fphone: this.managerPerson.phone,
                            id: this.managerPerson.teamId,
                            teamChangeId: this.managerPerson.teamChangeId,
                            personInChangeNo: this.managerPerson.IDCard,
                            projectId: this.managerPerson.projectId,
                            projectName: '',
                            supplierManagerId: this.managerPerson.name,
                            managerFiles:this.managerPerson.managerFiles,
                            userMessage: {
                                fcallname: this.managerPerson.loginNumber,
                                //floginnum: this.managerPerson.loginNumber,
                                fphone: this.managerPerson.phone,
                                id: this.managerPerson.name,
                                personInChangeNo: this.managerPerson.IDCard
                            },
                            userMessageName: this.managerPerson.loginNumber,
                            userType: '1',
                            changeReason:this.managerPerson.changeReason,
                            changeExplain:this.managerPerson.changeExplain||'',
                            userMessageId:this.managerPerson.name

                        };
                        apis.changeManage(params).then(res =>{
                            if (res.data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '提交成功!'
                                })
                                this.changeManagerFormVisible = false;
                                this.getContractBillsByStock();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.data.message
                                })
                            }

                        });
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            submitManager(){
                this.$refs.managerForm.validate((valid) => {
                    if (valid) {
                        let payload = {manager:this.manager, editIndex:this.editIndex}
                        this.addOrEditManager(payload)
                        this.managerFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            submit(){
            	this.isSubmit=true;
                this.submitManagers().then((res) => {
                    if(res.data.result){
                        this.$confirm(res.data.message||'操作成功！', '', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            showClose: false,
                            type: 'success',
                            center: true
                        }).then(() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        },() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        })
                        window.sessionStorage.setItem(this.$route.name,'saved')
                    }else{
                    	this.isSubmit=false;
                        this.$alert(res.data.message)
                    }
                }, err => {
                	this.isSubmit=false;
                    this.$alert(err)
                })
            },
            getTeamChange: function () {
                this.getTeamChangeByManager(null)
            },
            getContractBillsByStock: function(){
                let that = this;
                let data = {
                    stockId: that.$root.stockId,
                    contractName: that.form.name,
                    pageNum: that.contractBillPagination.pageNumber,
                    pageSize: that.contractBillPagination.pageSize
                }
                apis.getContractBillsByStock(data).then(res =>{
                    if (res.data.result) {
                        this.contractBillPagination.total = res.data.value.count
                        this.contractBillPagination.pageNumber = res.data.value.pageNo
                        this.contractBills = res.data.value.list||[];
                    }

                });
            },
            getTeamChangeByContract: function (contractId) {
                let data = {
                    contractBillId: contractId,
                    userType:'1',
                    selectStatus:['-1','0','1'],
                    pageNum:this.teamChangePagination.pageNumber,
                    pageSize:this.teamChangePagination.pageSize
                }
                apis.getTeamChangeByContract(data).then(res =>{
                    if (res.data.result) {
                        this.teamChangePagination.total = res.data.value.count
                        this.teamChangePagination.pageNumber = res.data.value.pageNo
                        this.managerChangeRecords = res.data.value.list||[];
                    }

                });
            },
            // 选择状态
            reasonChange(val){
                if(val == '3'){
                    this.changeExplainShow = true;
                }else{
                    this.changeExplainShow = false;
                }
            },
            getProjectManagerList(){
                let data = {
                    fid:this.fid
                }
                if(data.fid){
                    apis.getProjectManagerList(data).then(res =>{
                        if (res.data.result) {
                            this.projectManagerList = res.data.value.list||[];
                        }
                    });
                }
            },
            // 变更记录分页
            changeHandleCurrentChange(val){
                this.contractBillPagination.pageNumber = val;
                this.getContractBillsByStock();
            },
            changeTeamCurrentChange(val){
                this.teamChangePagination.pageNumber = val;
                this.getTeamChangeByContract(this.contractId);
            },
            setPhotoList : function(response, file, fileList) {
                this.manager.baseFileList = []
                this.manager.baseFileList = this.setFileLists(file, fileList)
            },
            handleChange : function(response, file, fileList){
                this.managerPerson.managerFiles = this.setFileLists(file, fileList)
            },
            handleExceed(files, fileList) {
                this.$message.warning('当前限制选择 1 个文件');
            },
            setFileLists (file, fileList) {
                let fs = [];
                fileList.forEach(function (item) {
                    if (item.response) {
                        let f = item.response.basefiles[0];
                        item.bizTableName = f.biztablename;
                        item.bizTablePkName = f.biztablepkname;
                        item.bizTablePkValue = f.biztablepkvalue;
                        item.fid = f.fid;
                        item.fileCatagoryId = f.filecatagoryid;
                        item.fileDesc = f.filedesc;
                        item.fileOldName = f.fileoldname;
                        item.name = f.fileoldname;
                        item.fileName = f.filename;
                        item.filePath = f.filepath;
                        item.fileSize = f.filesize;
                        item.fileType = f.filetype;
                        item.sort = f.sort;
                    }
                    fs.push(item);
                });
                return fs
            },
            setManagerPhone () {
                if (this.manager.idCard.length == 18) {
                    this.manager.mobile = this.linksMap[this.manager.idCard]
                }
            },
            // 选择项目经理
            changeName(value){
                this.backProjectManagerId = value;
                let manager = this.projectManagerList.find(item => item.id == value);
                if(manager){
                    this.managerPerson.IDCard = manager.idCard;
                    this.managerPerson.phone = manager.mobile;
                    this.managerPerson.loginNumber = manager.name;
                    this.managerPerson.supplierManagerId = manager.supplierManagerId;
                }
            },
            getChanageDetail(obj,flag){
                console.log(obj,'getChanageDetail')
                this.operateTitle = "项目经理变更";
                this.changeManagerFormVisible = true;
                this.managerPerson.teamId = obj.teamId;
                this.managerPerson.teamChangeId = obj.id;
                this.managerPerson.contractId = obj.contractId;
                this.managerPerson.projectId = obj.projectId;
                this.approveStatus = obj.approveStatus;
                this.changeManageShow = obj.approveStatus == 0 ? true : false;
                if (!flag) {
                    this.changeManageShow = true;
                    this.approveStatus = '0';
                }
                let data = {
                    id: obj.id,
                    contractBillId: obj.contractId
                }
                apis.getTeamChangeDetail(data).then(res =>{
                    if (res.data.result) {
                        this.managerPerson.changeReason = res.data.value.changeReason;
                        this.managerPerson.changeExplain = res.data.value.changeExplain;
                        this.managerPerson.oldUserMessageName = res.data.value.oldUserMessageName || res.data.value.userMessageName;
                        this.managerPerson.name = res.data.value.managerId;
                        this.managerPerson.managerFiles = res.data.value.baseFiles || [];
                        this.approveRemark = res.data.value.approveRemark;
                        if(res.data.value.approveStatus !='0') {
                            if (flag) {
                                this.managerPerson.managerFiles = [];
                            }
                        }
                        if(res.data.value.approveStatus =='2') {
                            this.managerPerson.managerFiles = res.data.value.baseFiles || [];
                            if (this.managerPerson.managerFiles && this.managerPerson.managerFiles.length > 0) {
                                this.managerPerson.managerFiles.forEach(item => {
                                    item.name = item.fileName
                                    item.fileOldName = item.fileName
                                })
                            }
                        }
                        this.changeExplainShow = false;
                        if (res.data.value.changeReason == 3) {
                            this.changeExplainShow = true;
                        }
                        let data1 = {
                            fid: obj.contractId,
                            id: !flag ? '-1' : ''
                        }
                        apis.getManagerByContractId(data1).then(res1 =>{
                            if (res1.data.result) {
                                this.projectManagerList = [];
                                if (res1.data.value && res1.data.value.length) {
                                    this.projectManagerList = res1.data.value || [];
                                    let person = res1.data.value.find(i => i.id == res.data.value.managerId);
                                    if(person){
                                        this.managerPerson.IDCard = person.idCard;
                                        this.managerPerson.phone = person.mobile;
                                        this.managerPerson.loginNumber = person.name;
                                    }
                                }
                            }

                        });
                        if (flag) {
                            this.managerPerson.IDCard = "";
                            this.managerPerson.phone = "";
                        }
                    }

                });
            },
            getChangeHistory(contractId){
                this.contractId = contractId;
                this.getTeamChangeByContract(contractId);
                this.recordDialogVisible = true;
            },
            checkStatus(){
                return apis.getLittleStatus(this.$root.stockId,this.hasLittleStatus012,this.hasLittleStatus3)
            },
            recallChanage(row) {
                let params = {id:row.id};
                this.$confirm('此操作将撤回该条变更记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    apis.recallChangeManage(params).then((res)=>{
                        if (res.data.result) {
                            this.$message({
                                type: 'success',
                                message: '撤回成功!'
                            })
                            this.getContractBillsByStock();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }).catch((e) => {
                    this.$message({
                        type: 'info',
                        message: '已取消撤回'
                    })
                })
            },
            deleteChanage(row) {
                let params = {id:row.id};
                this.$confirm('此操作将删除该条变更记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    apis.deleteRecallChangeManage(params).then((res)=>{
                        if (res.data.result) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            this.getContractBillsByStock();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }).catch((e) => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            }
        },
        created(){
            this.$root.loading = true
            this.getManagers().then((r)=>this.$root.loading = false).catch((err)=>this.$root.loading = false)
            this.linksMap = {}
            Promise.all([this.getLinkPersons()
            ]).then(r=>{
                this.$nextTick(function(){
                    this.linkpersons.forEach(item => {
                        this.linksMap[item.idCard] = item.fphone
                    })
                    this.$root.loading = false
                })
            }).catch(err=>this.$root.loading = false)
        },
        mounted(){
            this.basicIsShow = window.sessionStorage.getItem('basicIsShow')=='true'?true:false

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .achivement_span {
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 80px;
        overflow: hidden;
        display: block;
    }

    .info-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: url(../../../assets/imgs/icon-info.png) 0 center no-repeat;
        padding: 20px 30px;
        font-size: 14px;
        margin-top: -20px;
        border-bottom: 1px solid #e6e6e6;
    }
    .buttonDiv {
		cursor: pointer;
	}
    .buttonDiv:hover {
		color: #f38619;
	}
</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Manager.vue